import { createSlice } from "@reduxjs/toolkit";

import {
  getCustomerSubscriptionById,
  updateSubscription,
  pauseSubscription,
  cancelSchedulePause,
  cancelSubscription,
  updateSubscriptionTenant,
  getCancelQuestions,
  saveCancelQuestions
} from "./actions";
import {
  getAddons,
  getPlanDetails,
  getCustomerId,
} from "../actions";

const initialState = {
  loadedFirstTime: false,
  addonsObtained: false,
  subscriptionObtained: false,
  customerObtained: false,
  loading: false,
  addons: [],
  subscription: {},
  billingCountry: "",
  pauseModalOpen: false,
  cancelModalOpen: false,
  cancelStep: 1,
  questionsObtained: false,
  questions: [],
  modalLoading: false,
  statusChanging: false,
  subscriptionSelected: {},
  subscriptionCanceled: false,
  tenantUpdated: false,
  planDetailsObtained: false,
  planDetails: {},
};

const mySubscriptionSlice = createSlice({
  name: "mySubscription",
  initialState: initialState,
  reducers: {
    resetMySubscription: () => initialState,
    openPauseModal: (state) => {
      state.pauseModalOpen = true;
    },
    closePauseModal: (state) => {
      state.pauseModalOpen = false;
    },
    openCancelModal: (state) => {
      state.cancelModalOpen = true;
    },
    closeCancelModal: (state) => {
      state.cancelModalOpen = false;
      state.cancelStep = 1;
    },
    selectSubscription: (state, action) => {
      state.subscriptionSelected = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomerSubscriptionById.fulfilled, (state, action) => {
      //state.loadedFirstTime = (state.planDetailsObtained && state.addonsObtained && state.customerObtained) ? true : false;
      state.loadedFirstTime = (state.planDetailsObtained && state.customerObtained) ? true : false;
      state.subscriptionObtained = action.payload.success ? true : false;
      state.subscription = action.payload.success ? action.payload.data[0] : {};
    });
    builder.addCase(getCustomerSubscriptionById.pending, (state, action) => {});
    builder.addCase(getCustomerSubscriptionById.rejected, (state) => {});

    builder.addCase(getAddons.fulfilled, (state, action) => {
      state.loadedFirstTime = (state.planDetailsObtained && state.subscriptionObtained && state.customerObtained) ? true : false;
      state.addonsObtained = action.payload.success?true:false;
      state.addons = action.payload.success ?action.payload.data:[];
      state.loading = false;
    });
    builder.addCase(getAddons.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAddons.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getCustomerId.fulfilled, (state, action) => {
      //state.loadedFirstTime = (state.planDetailsObtained && state.subscriptionObtained && state.addonsObtained) ? true : false;
      state.loadedFirstTime = (state.planDetailsObtained && state.subscriptionObtained) ? true : false;
      state.customerObtained = true;
      state.billingCountry = action.payload.data && action.payload.data.customer && action.payload.data.customer.billingAddress && action.payload.data.customer.billingAddress.country ? action.payload.data.customer.billingAddress.country : "";
    });
    builder.addCase(getCustomerId.pending, (state) => { });
    builder.addCase(getCustomerId.rejected, (state) => { });

    builder.addCase(updateSubscription.fulfilled, (state, action)=>{
      state.loading = false;
      state.subscription = action.payload.success ? action.payload.data._response.subscription : state.subscription;
    })
    builder.addCase(updateSubscription.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(updateSubscription.rejected, (state) => {
      state.loading = false;
    })

    builder.addCase(pauseSubscription.fulfilled, (state, action) => {
      state.pauseModalOpen = false;
      state.modalLoading = false;
      state.subscription = action.payload.success ? action.payload.data : state.subscription
    })
    builder.addCase(pauseSubscription.pending, (state) => {
      state.modalLoading = true;
    })
    builder.addCase(pauseSubscription.rejected, (state) => {
      state.modalLoading = false;
    })

    builder.addCase(cancelSchedulePause.fulfilled, (state, action) => {
      state.statusChanging = false;
      state.subscription = action.payload.success ? action.payload.data : state.subscription
    })
    builder.addCase(cancelSchedulePause.pending, (state) => {
      state.statusChanging = true;
    })
    builder.addCase(cancelSchedulePause.rejected, (state) => {
      state.statusChanging = false;
    })

    builder.addCase(getCancelQuestions.fulfilled, (state, action) => {
      state.modalLoading = false;
      state.questionsObtained = action.payload && action.payload.success? true: false;
      state.questions = action.payload && action.payload.data ? action.payload.data : [];
    });
    builder.addCase(getCancelQuestions.pending, (state) => {
      state.modalLoading = true;
    });
    builder.addCase(getCancelQuestions.rejected, (state) => {
      state.modalLoading = false;
    });

    builder.addCase(saveCancelQuestions.fulfilled, (state) => {
      state.modalLoading = false;
      state.cancelStep = 2;
    });
    builder.addCase(saveCancelQuestions.pending, (state) => {
      state.modalLoading = true;
    });
    builder.addCase(saveCancelQuestions.rejected, (state) => {
      state.modalLoading = false;
    });

    builder.addCase(cancelSubscription.fulfilled, (state, action) => {
      state.subscriptionCanceled = true;
    });
    builder.addCase(cancelSubscription.pending, (state) => {
      state.modalLoading = true;
    });
    builder.addCase(cancelSubscription.rejected, (state) => {
      state.modalLoading = false;
    });

    builder.addCase(updateSubscriptionTenant.fulfilled, (state, action) => {
      state.modalLoading = false;
      state.tenantUpdated = true;
    });
    builder.addCase(updateSubscriptionTenant.pending, (state) => {
      state.modalLoading = true;
    });
    builder.addCase(updateSubscriptionTenant.rejected, (state) => {
      state.modalLoading = false;
    });
    builder.addCase(getPlanDetails.fulfilled, (state, action) => {
      state.planDetailsObtained = true;
      state.planDetails = action.payload && action.payload.data && action.payload.data.metadata ? action.payload.data.metadata : {};
      //state.loadedFirstTime = (state.subscriptionObtained && state.addonsObtained && state.customerObtained) ? true : false;
      state.loadedFirstTime = (state.subscriptionObtained && state.customerObtained) ? true : false;
    })
    builder.addCase(getPlanDetails.pending, (state, action) => {})
    builder.addCase(getPlanDetails.rejected, (state, action) => {
      state.planDetailsObtained = true;
    })
  }
})

export const {
  resetMySubscription,
  openPauseModal,
  closePauseModal,
  openCancelModal,
  closeCancelModal,
  selectSubscription,
  setSubscriptionId } = mySubscriptionSlice.actions;
export default mySubscriptionSlice.reducer;